import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.regexp.search.js";
import "core-js/modules/es6.array.find.js";
import { mainlistDefault } from "../../common/consts";
export function SET_PANEL(state, payload) {
  var panels = state.panelSides;
  panels[payload.side] = payload.data;
  state.panelSides = Object.assign({}, panels);
}

/**
 * Spit a panel in half.
 *
 * @param state
 * @param panel
 * @constructor
 */
export function SPLIT(state, panel) {
  state.panelSides = Object.assign({}, state.panelSides, state.panelSides[panel] = {});
}

/**
 * Remove a panel.
 *
 * @param state
 * @param panel
 * @constructor
 */
export function REMOVE(state, panel) {
  state.panelSides = Object.assign({}, state.panelSides, state.panelSides[panel] = null);
}
export function SET_OPEN_FLOAT_PANEL(state, status) {
  state.openFloatPanel = status;
}
export function SET_FLOAT_PANEL_CONTENT(state, data) {
  state.floatPanel = data;
}
export function SET_FLOAT_PANEL_TITLE(state, title) {
  state.floatPanelTitle = title;
}
export function RESET_PANEL_DATA(state, side) {
  state.mainlist.mainlists[side] = mainlistDefault;
  state.search.queries[side] = [];
}
export function UPDATE_QUERY(state, payload) {
  var left = state.mainlistLeft.data.find(function (q) {
    return q.id === payload.id;
  });
  left && Object.assign(left, payload.query);
  var right = state.mainlistRight.data.find(function (q) {
    return q.id === payload.id;
  });
  right && Object.assign(right, payload.query);

  // Find attached query.
  if (payload.parentId) {
    var _left = state.mainlistLeft.selected.find(function (q) {
      return q.id === payload.parentId;
    });
    var leftAttached = _left && _left.attached && _left.attached.find(function (q) {
      return q.id === payload.id;
    });
    leftAttached && Object.assign(leftAttached, payload.query);
    var _right = state.mainlistRight.selected.find(function (q) {
      return q.id === payload.parentId;
    });
    var rightAttached = _right && _right.attached && _right.attached.find(function (q) {
      return q.id === payload.id;
    });
    rightAttached && Object.assign(rightAttached, payload.query);
  }
}
export function GET_QUERY(state, payload) {
  state.selectedQuery = payload;
}